/** The footer's primary button: "Continue" on inner steps, the CTA label on
 *  the last. Inline brand fill survives Tailwind Preflight's button reset. */
export function PrimaryCta({
  enabled,
  isLast,
  ctaLabel,
  onCta,
  goNext,
}: {
  enabled: boolean;
  isLast: boolean;
  ctaLabel: string;
  onCta?: () => void;
  goNext: () => void;
}) {
  return (
    <button
      className="nb-cdrawer-btn nb-cdrawer-btn--primary"
      disabled={!enabled}
      style={{
        background: 'var(--nb-primary)',
        color: '#fff',
        opacity: enabled ? 1 : 0.5,
        cursor: enabled ? 'pointer' : 'not-allowed',
      }}
      onClick={isLast ? onCta : goNext}
    >
      {isLast ? ctaLabel : 'Continue'}
    </button>
  );
}
